(function () {
    'use strict';

    realmCommerceApp.controller("CartItemsController", CartItemsController);

    /*@ngInject*/
    function CartItemsController($uibModalInstance, cartService, cartItemModel, messagesService) {
        var vm = this;

        vm.cartItemModel = {};
        vm.removeItem = removeItem;
        vm.removeItems = removeItems;
        vm.cancel = cancel;
        
        activate();

        function activate() {
            vm.cartItemModel = cartItemModel;
        }

        function removeItem() {
            $uibModalInstance.close(true);
        }
        
        function removeItems() {
            let items = angular.copy(cartService.getCart().items);
            $uibModalInstance.close(items);
            cartService.removeItems(items).then(function () {
                messagesService.success({ text : "Your cart has been cleared" });
            });
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }

    }
})();


// WEBPACK FOOTER //
// ./static/js/app/cart/cart.items.controller.js